import React, { Component } from 'react';
import Swiper from 'swiper/dist/js/swiper.min.js';
import 'swiper/dist/css/swiper.min.css';

// Style
import './style.css'

// Images e Assets
import alexandre from '../../assets/ale.jpeg'
import hamsa from '../../assets/hamsa.jpg'
import artistaPrev from '../../assets/artista-prev.png'
import artistaNext from '../../assets/artista-next.png'
import aspas from '../../assets/aspas.png'

export default class Quemsomos extends Component {
    
    state = {
        slideItems: []
    }

    componentDidMount() {
        const dataSlide = [
            {
                message: 'Sócio-fundador da Plataforma, é diretor de programas de televisão e trabalhou por 20 anos em novelas da TV Globo, tais como Família é Tudo, Salve-se Quem Puder, Orgulho e Paixão, Haja Coração, Alto Astral, Salve Jorge, Araguaia, Caminho das Índias, Sete Pecados, Amazônia, América, Malhação, Celebridade, Mulheres Apaixonadas, Coração de Estudante e A Padroeira. Com formação em Cinema em Nova York, Alexandre é membro da International Academy for Television Arts and Science – a organização responsável pelos prêmios Emmy, que são concedidos anualmente a programas de televisão que demonstram padrões excepcionais de qualidade.',
                name: 'Alexandre Klemperer ',
                role: 'CEO',
                avatar: alexandre
            },
            {
                message: 'Diretor de séries, novelas e filmes como Os Dez Mandamentos, A Lei e o Crime, Mutantes, Pecado Mortal, Vidas em Jogo, Arpoador – Praia e Democracia, Apocalipse, Jezabel, entre outros. Iniciou sua carreira nos EUA trabalhando em filmes publicitários, corporativos e vídeo clipes. Formado em TV e Cinema Digital pela Universidade da Flórida, pós-graduação pela Universidade de Cambridge, e mestrado pela Fundação Getúlio Vargas.',
                name: 'Hamsa Wood',
                role: 'CTO',
                avatar: hamsa
            }
        ];

        let arr = [];
        dataSlide.map((elem, index) => {
            arr.push(
                <div key={index} className="swiper-slide">
                    <div className="slide-cont">
                        <div className="quadro-quemsomos">
                            <img src={aspas} />
                            <div className="quadro-quemsomos-texto">
                                {elem.message}
                            </div>
                            <div className="quadro-quemsomos-nome">
                                {elem.name}
                                <span>{elem.role}</span>
                            </div>
                        </div>
                        <div className="quemsomos-avatar">
                            <img src={elem.avatar} />
                        </div>
                    </div>
                </div>
            )
        })

        this.setState({slideItems: arr}, () => {
            const depoimentosSwiper = new Swiper('.quemsomos-slide', {
                slidesPerView: 2,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.quemsomos-next',
                    prevEl: '.quemsomos-prev'
                },
                breakpoints: {
                    1079: {
                        slidesPerView: 1,
                    }
                }
            });
        })
    }

    render() {
        return (
            <div id="quemsomos" className="quemsomos-section">
                <div className="quemsomos-topo">
                    <h2>Quem somos</h2>
                    <p>Olha só a equipe que está por trás do Ooppah!</p>
                </div>
                <div className="container">
                    <div className="quemsomos-slide swiper-container">
                        <div className="swiper-wrapper">
                            {this.state.slideItems}
                                          
                        </div>
                    </div>
                    <div className="quemsomos-slide-nav">
                        <div className="quemsomos-prev"><img src={artistaPrev} /></div>
                        <div className="quemsomos-next"><img src={artistaNext} /></div>
                    </div>
                </div>
            </div>
        )
    }
}
